var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.style,{tag:"component",attrs:{"name":_vm.name,"pin":_vm.pin,"mapData":_vm.mapData,"isRight":_vm.isRight,"isLeft":_vm.isLeft,"isTop":_vm.isTop,"gradient":_vm.gradient,"textColor":_vm.textColor,"mapHeight":_vm.mapHeight,"isDefault":_vm.isDefault,"isStart":_vm.isStart,"labelWidth":_vm.labelWidth},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }